import React, {useCallback, useEffect, useMemo} from "react";
import {Drawer,} from '@mui/material';
import useStyles from './useStyles';
import {useSelector} from "react-redux";

const mapStateToProps = (state)=>{
  const {
    ui: {
      isDrawerOpen,
    } = {},
  } = state;
  return { isDrawerOpen }
}

export const DEFAULT_PALETTE_WIDTH = 280

const ResizebleDrawer = (props) => {

  const {
    minWidth=0,
    maxWidth=280,
    content,
    paletteWidth= DEFAULT_PALETTE_WIDTH,
    setPaletteWidth = () => {},
  } = props

  const classes = useStyles();

  const {isDrawerOpen} = useSelector(mapStateToProps)

  const handleResize = () => {
    const windowWidth = window.innerWidth;
    if (windowWidth <= 480) {
      setPaletteWidth(0); // Прячем элемент
    } else if (windowWidth <= 768) {
      setPaletteWidth(200);
    } else {
      setPaletteWidth(DEFAULT_PALETTE_WIDTH);
    }
  };

  const calculatedPalletteWidth = useMemo(() => {

    const windowWidth = window.innerWidth;

    if (windowWidth <= 480) {
      return 0
    } else if (windowWidth <= 768) {
      return 200;
    } else {
      return DEFAULT_PALETTE_WIDTH;
    }
  }, [window.innerWidth])

  useEffect(() => {
    handleResize();
    window.addEventListener('resize', handleResize);
    return () => {
      window.removeEventListener('resize', handleResize);
    };
  }, []);


  const handleMouseDown = useCallback(e => {
    document.onmouseup = handleMouseUp;
    document.onmousemove = handleMouseMove;
  }, []);

  const handleMouseUp = useCallback(e => {
    document.onmouseup = null;
    document.onmousemove = null;
  }, []);

  const handleMouseMove = useCallback(e => {
    console.log('e.clientX - document.body.offsetLeft',(e.clientX - document.body.offsetLeft))
    /*const newWidth = e.clientX - document.body.offsetLeft - 30;
    if(newWidth < minWidth){
      setPaletteWidth(minWidth);
    }else if(newWidth > maxWidth){
      setPaletteWidth(maxWidth);
    }else{
      setPaletteWidth(newWidth);
    }*/
  }, []);

  useEffect(() => {
    setPaletteWidth(isDrawerOpen ? calculatedPalletteWidth : 0)
  }, [isDrawerOpen, calculatedPalletteWidth])

  return (

      <>
        <Drawer
            className={classes.drawer}
            PaperProps={{ style: { width: paletteWidth } }}
            /*PaperProps={{ style: { width: calculatedPaletteWidth } }}*/
            variant={'persistent'}
            open={isDrawerOpen}
        >
          <div className={classes.toolbar} />
          <div onMouseDown={e => handleMouseDown(e)} className={classes.dragger} />
          {content}
          {/* <Divider /> */}
        </Drawer>
      </>
  );
}

export default ResizebleDrawer;
